// generated file -- do not edit
export const Version = {
  tag: 'v0.22.2',
  SHA: '6040aa970465795e57436804d922bfd436a39b6f',
  shortSHA: '6040aa97',
  buildTime: 'Fri, 11 Apr 2025 20:00:11 GMT',
};
